import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=f2c6b656&scoped=true&lang=pug&"
import script from "./FlipCard.vue?vue&type=script&lang=js&"
export * from "./FlipCard.vue?vue&type=script&lang=js&"
import style0 from "./FlipCard.vue?vue&type=style&index=0&id=f2c6b656&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c6b656",
  null
  
)

component.options.__file = "FlipCard.vue"
export default component.exports